/**
 * Shared constants for the Notification Center feature.
 * Used by both NotificationCenterPage.vue and NotificationCenterDropdown.vue
 * so the two components stay in sync.
 */

// Internal notification category used by the components' display logic
export const NOTIFICATION_TYPE = {
  WEATHER: 'weather',
  ORDER: 'order'
};

// Order status constants (canonical, lowercase, matches MetadataJson status vocabulary)
export const ORDER_STATUS = {
  PLACED: 'placed',
  EN_ROUTE: 'en_route',
  ARRIVED: 'arrived',
  DELIVERED: 'delivered'
};

// Server notification type codes returned by the unified Notification Center endpoint
export const SERVER_NOTIFICATION_TYPE = {
  ORDER: 'OrderUpdate',
  WEATHER: 'WeatherAlert'
};

// messageKey values that represent a delivered order (drives the "Leave Delivery Feedback" action).
// TODO: confirm the final messageKey vocabulary with the backend and update this list.
export const DELIVERED_MESSAGE_KEYS = ['orderupdate.delivered'];
